/**
 * Utilidades para RUT y teléfono chileno.
 * Uso: import { formatRut, isValidRut, isValidTelefono } from '../utils/rutUtils';
 */

/**
 * Formatea un RUT chileno: 12.345.678-9
 * Acepta entrada cruda (con o sin puntos/guion).
 */
export function formatRut(raw) {
  let rut = raw.replace(/[^0-9kK]/g, '').toUpperCase();
  if (rut.length > 9) rut = rut.slice(0, 9);
  if (rut.length <= 1) return rut;
  const cuerpo = rut.slice(0, -1);
  const dv = rut.slice(-1);
  let cuerpoFmt = '';
  for (let i = cuerpo.length; i > 0; i -= 3) {
    const start = Math.max(i - 3, 0);
    cuerpoFmt = (start > 0 ? '.' : '') + cuerpo.slice(start, i) + cuerpoFmt;
  }
  return `${cuerpoFmt}-${dv}`;
}

/**
 * Valida formato de RUT chileno (7-9 dígitos + dígito verificador numérico o K).
 * No valida matemáticamente el DV — solo el formato.
 */
export function isValidRut(rut) {
  const rutClean = rut.replace(/\./g, '').replace(/-/g, '').toUpperCase();
  return /^\d{7,9}[0-9K]$/.test(rutClean);
}

/**
 * Valida teléfono celular chileno.
 * Acepta: +56XXXXXXXXX (11 chars) o 9 dígitos solos (ej: 912345678).
 */
export function isValidTelefono(telefono) {
  return /^\+56\d{9}$/.test(telefono) || /^[569]\d{8}$/.test(telefono);
}
